"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var BandaidIcon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(BandaidIcon, _PureComponent);

  function BandaidIcon() {
    _classCallCheck(this, BandaidIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(BandaidIcon).apply(this, arguments));
  }

  _createClass(BandaidIcon, [{
    key: "render",
    value: function render() {
      var style = {
        fill: this.props.color || '#600460'
      };
      return _react2.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 34.962 35",
        style: style
      }, _react2.default.createElement("defs", null, _react2.default.createElement("style", null, "opacity: .3")), _react2.default.createElement("g", {
        id: "prefix__bandaid",
        transform: "translate(-.05)"
      }, _react2.default.createElement("path", {
        id: "prefix__Path_1575",
        d: "M22.274 104.615L11.54 93.9S2 100.855 8.8 107.658s13.474-3.043 13.474-3.043z",
        className: "prefix__cls-1",
        "data-name": "Path 1575",
        transform: "translate(-5.112 -76.154)"
      }), _react2.default.createElement("path", {
        id: "prefix__Path_1576",
        d: "M93.7 11.928l10.715 10.734s9.544-6.955 2.74-13.758S93.7 11.928 93.7 11.928z",
        className: "prefix__cls-1",
        "data-name": "Path 1576",
        transform: "translate(-75.952 -5.275)"
      }), _react2.default.createElement("g", {
        id: "prefix__Group_2692",
        "data-name": "Group 2692",
        transform: "translate(.05)"
      }, _react2.default.createElement("path", {
        id: "prefix__Path_1577",
        d: "M32.319 2.7a9.171 9.171 0 0 0-13 0L2.743 19.276A9.213 9.213 0 0 0 9.244 35a9.136 9.136 0 0 0 6.5-2.7l16.575-16.576a9.216 9.216 0 0 0 0-13.024zM17.522 26.5l-9-9.015 9-9 9 9zm-8.278 5.646a6.272 6.272 0 0 1-4.5-1.871 6.376 6.376 0 0 1 0-9L6.523 19.5l9 9-1.776 1.776a6.3 6.3 0 0 1-4.503 1.87zM30.316 13.7l-1.776 1.776-9-9 1.78-1.77a6.361 6.361 0 1 1 9 9z",
        className: "prefix__cls-2",
        "data-name": "Path 1577",
        transform: "translate(-.05)"
      }), _react2.default.createElement("path", {
        id: "prefix__Path_1578",
        d: "M51.762 140.062a1.056 1.056 0 1 0 1.493 0 1.049 1.049 0 0 0-1.493 0z",
        className: "prefix__cls-2",
        "data-name": "Path 1578",
        transform: "translate(-41.736 -113.339)"
      }), _react2.default.createElement("path", {
        id: "prefix__Path_1579",
        d: "M34.462 122.762a1.056 1.056 0 1 0 1.493 0 1.049 1.049 0 0 0-1.493 0z",
        className: "prefix__cls-2",
        "data-name": "Path 1579",
        transform: "translate(-27.706 -99.309)"
      }), _react2.default.createElement("circle", {
        id: "prefix__Ellipse_21",
        cx: "1.058",
        cy: "1.058",
        r: "1.058",
        className: "prefix__cls-2",
        "data-name": "Ellipse 21",
        transform: "translate(6.019 26.836)"
      }), _react2.default.createElement("path", {
        id: "prefix__Path_1580",
        d: "M122.762 34.462a1.056 1.056 0 1 0 1.493 0 1.049 1.049 0 0 0-1.493 0z",
        className: "prefix__cls-2",
        "data-name": "Path 1580",
        transform: "translate(-99.318 -27.696)"
      }), _react2.default.createElement("circle", {
        id: "prefix__Ellipse_22",
        cx: "1.058",
        cy: "1.058",
        r: "1.058",
        className: "prefix__cls-2",
        "data-name": "Ellipse 22",
        transform: "translate(26.411 9.714)"
      }), _react2.default.createElement("circle", {
        id: "prefix__Ellipse_23",
        cx: "1.058",
        cy: "1.058",
        r: "1.058",
        className: "prefix__cls-2",
        "data-name": "Ellipse 23",
        transform: "translate(26.826 6.029)"
      }))));
    }
  }]);

  return BandaidIcon;
}(_react.PureComponent);

exports.default = BandaidIcon;